import { LoadingButton, LoadingButtonProps } from "@mui/lab";
import { ButtonBaseOwnProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDownloadFile } from "src/shared/data-access/downloadFile/useDownloadFile";
import DownloadIcon from "@mui/icons-material/Download";

type TFileDownloadButtonProps = {
  params?: { key: string; value: string }[];
  text?: string;
  url?: string;
} & ButtonBaseOwnProps &
  LoadingButtonProps;

function FileDownloadButton(props: TFileDownloadButtonProps) {
  const downloadFileMutation = useDownloadFile();
  const { t } = useTranslation();

  const {
    params = [],
    url = `${import.meta.env.VITE_APP_API_URL}/document/downloadUserFile`,
    sx = { fontSize: "1rem" },
    children,
    text,
    variant = "outlined",
    endIcon = <DownloadIcon />,
    ...rest
  } = props;

  return (
    <LoadingButton
      {...rest}
      sx={sx}
      loading={downloadFileMutation.isLoading}
      variant={variant}
      endIcon={endIcon}
      onClick={() =>
        downloadFileMutation.mutate({
          url: url,
          params: params,
        })
      }
    >
      {text ?? children ?? t(text ?? "Προβολή Αρχείου")}
    </LoadingButton>
  );
}

export default FileDownloadButton;
